import styled from "styled-components";
import Wrapper from "../../assets/wrappers/Job";
import {
  FaInfinity,
  FaHourglassHalf,
  FaEdit,
  FaTrash,
  FaBirthdayCake,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { customFetch } from "../../utils/custom-fetch"; // ← הנתיב אצלך
import { useNavigate } from "react-router-dom";
import { Link, Form } from "react-router-dom";
const targetName = (t) =>
  t === "city"
    ? "ערים:"
    : t === "street"
    ? "רחובות:"
    : t === "building"
    ? "בניינים:"
    : "כללי";

/* ---------- component ---------- */
const ShowMessage = ({
  _id /* ← מזהה ההודעה */,
  messageType,
  messageDetails,
  target,
  createdAt,
  isActive,
  onDeleted /* callback אופציונלי מהרשימה */,
}) => {
  const navigate = useNavigate();
  const messageClass = isActive ? "active" : "inactive";

  /* ---- אייקון ---- */
  const getIcon = () => {
    if (messageType === "יום הולדת") return <FaBirthdayCake className="icon" />;
    return messageDetails.messageOption === "קבועה" ? (
      <FaInfinity className="icon" />
    ) : messageDetails.messageOption === "בין תאריכים" ? (
      <FaHourglassHalf className="icon" />
    ) : null;
  };

  /* ---- תצוגת יעד ---- */
  const renderTarget = () =>
    target.type === "city"
      ? target.cities.join(", ")
      : target.type === "street"
      ? target.streets.join(", ")
      : target.type === "building"
      ? target.buildings.join(", ")
      : "כללי";

  const renderRange =
    messageDetails.messageOption === "בין תאריכים"
      ? `${messageDetails.expirationDate} - ${messageDetails.startingDate}`
      : null;

  /* ---- מחיקה ---- */
  const handleDelete = async () => {
    if (!window.confirm("האם אתה בטוח שברצונך למחוק את ההודעה?")) return;
    try {
      await customFetch.delete(`/messages/${_id}`);
      toast.success("ההודעה נמחקה");
      onDeleted ? onDeleted(_id) : navigate(0); // רענון הרשימה
    } catch {
      toast.error("שגיאה במחיקת ההודעה");
    }
  };

  return (
    <StyledWrapper className={messageClass}>
      <header>
        <h5>{messageType}</h5>
        <div className="icon-container">{getIcon()}</div>
      </header>

      <div className="content">
        <p>
          <strong>{targetName(target.type)}</strong> {renderTarget()}
        </p>

        {messageType === "יום הולדת" && (
          <div>
            <p>
              <strong>שם החוגג:</strong> {messageDetails.celebratorName}
            </p>
            <p>
              <strong>הברכה:</strong> {messageDetails.greeting}
            </p>
            <p>
              <strong>תאריך יום ההולדת:</strong> {messageDetails.birthdayDate}
            </p>
          </div>
        )}
        {messageType !== "יום הולדת" && (
          <p>
            <strong>פרטי ההודעה:</strong> {messageDetails.text}
          </p>
        )}
        <p>
          <strong>נוצר בתאריך:</strong>{" "}
          {new Date(createdAt).toLocaleDateString("he-IL")}
        </p>
        {renderRange && (
          <p>
            <strong>בין התאריכים:</strong> {renderRange}
          </p>
        )}
      </div>

      <div className="btn-container">
        <Link
          to={`../messages/edit/${_id}`}
          className="btn btn-edit"
          title="ערוך הודעה"
        >
          <FaEdit />
        </Link>
        <button className="btn btn-delete" onClick={handleDelete}>
          <FaTrash />
        </button>
      </div>
    </StyledWrapper>
  );
};

/* ---------- styled ---------- */
const StyledWrapper = styled(Wrapper)`
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  transition: 0.3s;

  &.active {
    border-left: 5px solid #4caf50;
  }
  &.inactive {
    border-left: 5px solid #f44336;
    background: #ffe6e6;
  }

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .icon-container {
    font-size: 1.5rem;
    color: #ff9800;
  }

  .content {
    margin-top: 0.5rem;
    color: #555;
    p {
      margin: 5px 0;
    }
  }

  .btn-container {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    margin-top: 1rem;
    .btn {
      padding: 0.5rem 1rem;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      transition: 0.3s;
      &.btn-edit {
        background: #2196f3;
        color: #fff;
      }
      &.btn-delete {
        background: #f44336;
        color: #fff;
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }
`;

export default ShowMessage;
